import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { LIQUIDATION_DIFFERENCE_REASON_PATH } from '../../../../config/paths';
import LiquidationDifferenceReasonDeleteButton from './LiquidationDifferenceReasonDeleteButton';

const LiquidationDifferenceReasonToolbar = ({ liquidationDifferenceReasonId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton path={`${LIQUIDATION_DIFFERENCE_REASON_PATH}/${liquidationDifferenceReasonId}/edit`} />{' '}
      <LiquidationDifferenceReasonDeleteButton liquidationDifferenceReasonId={liquidationDifferenceReasonId} />
    </div>
  </ButtonToolbar>
);

LiquidationDifferenceReasonToolbar.propTypes = {
  liquidationDifferenceReasonId: PropTypes.number.isRequired,
};

export default LiquidationDifferenceReasonToolbar;
